const sections = {
  Contractor: {
    value: 'CONTRACTOR',
    label: 'ferryServices.form.contractor'
  },
  BasicDetails: {
    value: 'BASIC_DETAILS',
    label: 'ferryServices.form.basicData'
  },
  AdditionalData: {
    value: 'ADDITIONAL_DATA',
    label: 'ferryServices.form.additionalData'
  }
}
export default sections
